import '../App.css'
import React from 'react'
import './Races.css'
import TestCards from './TestCards';


function Races() {
    return (
        <div className='race-container'>

            
            <div className='Teris'>
                <TestCards />
            </div>

        </div>

    );
}

export default Races
